import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./NumberStepperStyles";

export default class NumberStepper extends Component {
  render() {
    const {
      input: { value, onChange, onFocus, onBlur }
    } = this.props;

    let valueString = value;

    if(typeof value === 'object' && 'number' in value) {
        valueString = value.number;
    }

    if(value === "") {
        valueString = 0;
    }

    return (
      <div className={css(styles.inputWrapper)}>
        <button
          type="button"
          className={css(styles.decrement, valueString === 0 && styles.greyed)}
          onClick={() => valueString !== 0 && onChange(valueString - 1)}
        />
        <input
          className={css(styles.input)}
          type="number"
          value={valueString}
          onChange={e => onChange(e)}
          onFocus={onFocus}
          onBlur={onBlur}
          min={0}
        />
        <button
          type="button"
          className={css(styles.increment)}
          onClick={() => onChange(valueString + 1)}
        />
      </div>
    );
  }
}
